import type { FC } from "react";
import { useCallback, useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import axios from "axios";
import { thunks as promptsThunks } from "src/thunks/prompts";
import { useTranslation } from "react-i18next";
import { useDispatch } from "src/store";
import toast from "react-hot-toast";
import { tokens } from "src/locales/tokens";
import { PromptMessage } from "src/types/prompts";
import ReactMarkdown from "react-markdown";

interface CardReviewTemplateProps {
  title: string;
  content?: string;
  messages: PromptMessage[];
  onGenerationFinished?: (text: string) => void;
}

export const CardReviewTemplate: FC<CardReviewTemplateProps> = (props) => {
  const [text, setText] = useState<string>("");

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { title, content, messages, onGenerationFinished } = props;

  const generate = useCallback(async () => {
    await dispatch(
      promptsThunks.runPrompt(
        i18n.language,
        {
          messages: messages,
        },
        (text) => {
          setText(text);
        },
        () => {
          toast.error(t(tokens.general.formError));
        },
        (text) => {
          setText(text);
          console.log("text", text);
          onGenerationFinished?.(text);
        },
        axios.CancelToken.source()
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, i18n.language, messages, t]);

  useEffect(() => {
    if (!content) {
      generate();
    }
  }, [generate, content]);

  return (
    <>
      {(text || content) && (
        <Card>
          <CardHeader title={title} />

          <CardContent
            sx={{
              mt: 0,
              pt: 0,
            }}
          >
            <ReactMarkdown>
              {text.length > 0 ? text : content ?? ""}
            </ReactMarkdown>
          </CardContent>
        </Card>
      )}
    </>
  );
};
